import { applySearchParametersToObject, getURLParameter } from "../../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import Task from "../../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLibrary from "../../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import AppModel from "../../../../../../shared/src/ranj/app/core/AppModel";
import GameEvent from "../../../../../../shared/src/ranj/app/core/GameEvent";

export default class InitCollaborationGameTask extends Task {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {AssetLibrary} assetLibrary 
     * @param {GameConfig} gameConfig 
     */
    constructor(dispatcher, assetLibrary, gameConfig) {
        super();

        this.execute = function(callback, progressCallback) {            
            var configJSON = assetLibrary.getAsset("gameConfig");
            if (ranj.DEBUG) {
                applySearchParametersToObject(window.top.location.search, configJSON);
                window.document.addEventListener("keyup", this._handleKeyUp);
            }
            gameConfig.setPropertiesFromObject(configJSON);

            const speedFactor = parseFloat(getURLParameter("speed"));
            AppModel.speedFactor = !isNaN(speedFactor) ? speedFactor : 1;

            callback(this);
        };

        this._handleKeyUp = function(e) {
            const c = String.fromCharCode(e.which);
            if (c == "R") {
                if (confirm("Are you sure you want to reset the savegame?")) {
                    dispatcher.dispatch(SaveEvent.CLEAR);
                    window.location.reload();
                }
            } else if (c=="E") {
                dispatcher.dispatch(GameEvent.COMPLETED);
            }
        }.bind(this);
    }


}